import { Component, OnInit } from '@angular/core';
import { Ope } from 'src/app/models/Ope';
import { DocServices } from 'src/app/services/docs/docs.services';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { Doc } from '../../../../domain/doc';
import { Subject, catchError, first, iif, map, of, takeUntil, tap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { SidebarService } from 'src/app/services/sideBare.service';
import { EnumTypeNotification } from 'src/app/enumeration/EnumTypeNotification';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'app-doc-list',
  templateUrl: './doc-list.component.html',
  imports: [CommonModule,ToastModule,ProgressBarModule,TableModule,ButtonModule],
  styleUrls: ['./doc-list.component.scss']
})
export class DocListComponent implements OnInit {

  docs: Doc[] = [];

  programmeseled!: Ope;
  docsDto!: any;
  afficheerrorDoc: boolean = false;
  urltoDowloand!: any;
  container!: boolean;
  private _destroy$: Subject<void> = new Subject();

  error!: string;
  constructor(public _sidebar: SidebarService, public share: shareOpeSevices, private servicedoc: DocServices) { }

  ngOnInit() {
    this.share.datasOpe$.subscribe(data => this.programmeseled = data);

    this.servicedoc.getDocumentsBynumOpe(this.programmeseled.numOpe).subscribe((data: any) => {
      this.docsDto = data;
      this.docsDto.forEach((element: any) =>
        this.docs.push({
          nom: element.nom,
          type: element.type,
          url: element.url,
          dm: element.dm,
          vignette: element.vignette,
          position: element.position,
          code: element.code
        })
      );

    })



  }
  split(chaine: string) {
    return chaine.substring(0, 10);
  }
  downloadFileonClick(path: string, code: number): any {

    this.share.showprogressbar = true;
    this.onScrollToAnchor();

    this.servicedoc.downloadDocumentsbyCode(code)
      .pipe(first(), map((data: any) => {
        if (data !== null || data !== undefined) {
          this._sidebar.addNewNotification(
            EnumTypeNotification.SUCCESS,
            `Documents  : ${data.nom}.${data.type} en cours de télécharment !`,
            '',
            true,
            true
          );
          setTimeout(() => {
            this._sidebar.addNewNotification(
              EnumTypeNotification.SUCCESS,
              'Téléchargé avec succès !',
              '',
              true,
              true

            );

            window.open(path);
            this.share.showprogressbar = false;
          }, 1500);
        }
        if (data === null || data === undefined) {
          this._sidebar.addNewNotification(
            EnumTypeNotification.INFO,
            `Document vide ou problème dans le fichier: ${data.url} - veuillez contacter un administrateur`,
            '',
            true,
            true
          );
          this.share.showprogressbar = false;
        }
      })
        , catchError(this.handleError), takeUntil(this._destroy$)).subscribe();
  }


  handleError = (error: HttpErrorResponse) => {


    if (error.status === 404 || error.status === 400) {

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Communication interrompu avec Open : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );

      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;

      }
      return of(error.message);

    } if (error.status === 503) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Service indsponible - code erreur : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
    //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

    if (error.status === 502) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Bad Gatway - POD ne repond pas - code erreur : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
    if (error.status === 504) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Timeout Gatway - code erreur ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }


    if (error.status === 500) {

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Mauvaise requette, veuillez bien selectionner les bons param - code erreur ' + error.status + ' .',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
    else {

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Erreur Inconnu  - code erreur ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      return of(error.message);
    }
  }
  onScrollToAnchor() {
    const sasa = document.getElementById("tagProgbar")
    sasa?.scrollIntoView({ behavior: 'smooth' })

  }
  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
  getIconFile(type: string): string {

    if (type === 'PDF') { return 'assets/images/icons/icon-pdf.svg' };
    if (type === '7Z') { return 'assets/images/icons/icon-zip.svg' };
    if (type === 'DOCX' || type === 'DOC') { return 'assets/images/icons/icon-doc.svg' };
    return 'assets/images/icons/icon-zip.svg';

  }

}
